export function localeLowerCase(value: string, locale = 'en'): string {
  return value.toLocaleLowerCase(locale);
}

export function localeUpperCase(value: string, locale = 'en'): string {
  return value.toLocaleUpperCase(locale);
}
